module.exports = __webpack_public_path__ + "img/consultation@2x.bfddb19.jpg";